import React from "react";
import { Link } from "react-router-dom";
import { LOGO, PHONE, LINKEDIN, SITE } from "../lib/i18n";

export default function Footer({ t }) {
  return (
    <footer data-testid="site-footer" className="bg-paper">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-12 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
        <div className="md:col-span-5">
          <img src={LOGO} alt="Nettpilot" className="h-10 w-auto opacity-85" />
          <p className="mt-4 text-sm text-mist max-w-sm">{t.footer.tagline}</p>
          <p className="mt-3 font-mono text-[10px] tracking-[0.2em] uppercase text-mist max-w-md">
            {t.footer.disclaimer}
          </p>
        </div>

        <div className="md:col-span-3 font-mono text-[12px] tracking-[0.16em] uppercase">
          <div className="text-mist mb-2">{t.footer.phone}</div>
          <a
            data-testid="footer-phone"
            href={`tel:${PHONE.replace(/\s+/g, "")}`}
            className="hover:text-ember transition-colors"
          >
            {PHONE}
          </a>
        </div>

        <div className="md:col-span-2 font-mono text-[12px] tracking-[0.16em] uppercase">
          <div className="text-mist mb-2">links</div>
          <a
            data-testid="footer-linkedin"
            href={LINKEDIN}
            target="_blank"
            rel="noreferrer"
            className="block hover:text-ember transition-colors"
          >
            {t.footer.linkedin}
          </a>
          <a
            data-testid="footer-site"
            href={SITE}
            target="_blank"
            rel="noreferrer"
            className="block mt-1 hover:text-ember transition-colors"
          >
            {t.footer.site}
          </a>
          <Link
            data-testid="footer-blog"
            to="/blog"
            className="block mt-1 hover:text-ember transition-colors"
          >
            Blogg
          </Link>
          <Link
            data-testid="footer-privacy"
            to="/personvern"
            className="block mt-1 hover:text-ember transition-colors"
          >
            {t.footer.privacy}
          </Link>
          <Link
            data-testid="footer-intel"
            to="/intel"
            className="block mt-1 hover:text-ember transition-colors"
            title="For researchers and AI agents — the citation-grade view"
          >
            /intel ↗
          </Link>
        </div>

        <div className="md:col-span-2 font-mono text-[10px] tracking-[0.22em] uppercase text-mist text-right">
          <div>made by</div>
          <div className="text-ink">a digital twin · w/ love & a hat</div>
        </div>
      </div>
      <div className="border-t border-rule">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-4 font-mono text-[10px] tracking-[0.2em] uppercase text-mist flex flex-wrap items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Nettpilot AS</span>
          <span>three-layer approach™ · since 2003</span>
        </div>
      </div>
    </footer>
  );
}
